<template>
  <div class="bridge-header">
    <!-- 左侧区域：返回按钮和标题 -->
    <div class="header-left">
      <el-button 
        type="primary"
        plain
        icon="el-icon-arrow-left" 
        @click="goBack" 
        class="back-btn">返回</el-button>
      <h3 class="bridge-title">{{ isEdit ? (bridgeName || '编辑桥梁') : '添加桥梁' }}</h3>
    </div>

    <!-- 中部区域：功能标签切换 -->
    <div class="header-center">
      <el-button-group class="action-group" v-if="isEdit && !isDrawingActive">
        <el-button 
          :class="{ 'active-tab': activeTab === 'info' }"
          size="medium"
          @click="$emit('tab-change', 'info')">
          桥梁信息
        </el-button>
        <el-button 
          :class="{ 'active-tab': activeTab === 'area' }"
          size="medium"
          @click="$emit('tab-change', 'area')">
          区域管理
        </el-button>

        <el-button 
          :class="{ 'active-tab': activeTab === 'blacklist' }"
          size="medium"
          @click="$emit('tab-change', 'blacklist')">
          船舶名单
        </el-button>
      </el-button-group>
    </div>

    <!-- 右侧区域占位，保持布局平衡 -->
    <div class="header-right-spacer"></div>
  </div>
</template>
<script>
export default {
  name: 'BridgeHeader',
  props: {
    // 是否为编辑模式
    isEdit: {
      type: Boolean,
      default: false
    },
    // 桥梁名称
    bridgeName: {
      type: String,
      default: ''
    },
    // 当前激活的标签页
    activeTab: {
      type: String,
      default: 'info'
    },
    // 是否正在绘制
    isDrawingActive: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    // 返回上一页
    goBack() {
      this.$emit('go-back');
    },
    
    // 标签页切换处理
    handleTabChange(tab) {
      this.$emit('tab-change', tab);
    },
    
    // 显示区域管理（包含警戒设置）
    showAlertSettings() {
      this.$emit('tab-change', 'area');
    }
  }
};
</script>
<style scoped>
.bridge-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 10px;
  height: 60px;
  background-color: #f5f7fa;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  width: 100%;
}

.header-left {
  display: flex;
  align-items: center;
  width: 30%;
}

.back-btn {
  margin-right: 10px;
  border-radius: 4px;
  font-size: 12px;
  padding: 7px 15px;
  height: 32px;
  line-height: 1;
  transition: all 0.3s ease;
}

.back-btn:hover {
  transform: translateX(-2px);
  opacity: 0.9;
}

.bridge-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}

.header-center {
  flex: 1;
  display: flex;
  justify-content: center;
}

.header-right-spacer {
  width: 30%; /* 匹配左侧宽度，保持平衡 */
}

.tab-radio-group {
  display: flex;
}

.fixed-width-tab {
  min-width: 100px;
  flex: 1;
  text-align: center;
  display: flex;
  justify-content: center;
}

/* 确保所有radio button具有相同的宽度和布局 */
.tab-radio-group .el-radio-button__inner {
  width: 100%;
  display: flex;
  justify-content: center;
}

/* 激活的标签页样式 */
.active-tab {
  color: #409EFF !important;
  background-color: #ecf5ff !important;
  border-color: #d9ecff !important;
  font-weight: bold;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .header-center {
    display: none; /* 在小屏幕上隐藏，可以改为下拉菜单 */
  }
  
  .bridge-title {
    max-width: 150px;
  }
}
</style>